import React from 'react';
import { Form, Table, Icon, Row, Button, Modal, Spin, Col, Tooltip } from 'antd';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Link } from 'dva/router';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent, SelectInput } from '../../../components';
import MultiplyItemsColumnRender from '../../common/Table/MultiplyItemsColumnRender';
import styles from '../styles.less';
import { CopyIcon, PencilIcon, TrashIcon } from '../../Icons';
import helpers from '../../../utils/helpers';

const FormItem = Form.Item;

class TargetGroupsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removedId: 0,
      filter: {
        search: undefined,
        category_id: undefined,
      },
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.DynamicContent.Title',
        description: 'Component.DynamicContent.Overview.Description',
      },
    });

    this.showNotifications();
    this.getCategoryies();
  }

  getData(psf) {
    const modifiedPsf = psf;
    const filter = {
      name: this.state.filter.search,
      category_id: this.state.filter.category_id,
    };

    if (modifiedPsf.sorting.includes('company_size')) {
      modifiedPsf.sorting = modifiedPsf.sorting.replace('company_size', 'company_min_size');
    } else if (!modifiedPsf.page) {
      modifiedPsf.page = '1';
    }

    if (filter.name !== '**') {
      modifiedPsf.filtered = true;
    }

    return this.props.dispatch({
      type: 'targetGroups/loadList',
      payload: { ...modifiedPsf, filter },
    });
  }

  getCategoryies() {
    this.props.dispatch({ type: 'categories/loadList',
      payload: {
        filter: { client_id: this.props.app.selectedClient.id },
      } });
  }

  copyTG(id) {
    this.props.dispatch({
      type: 'targetGroups/create',
      payload: { id, duplicate: true },
    }).then((data) => {
      this.props.dispatch({
        type: 'app/goToRoute',
        payload: {
          routeName: 'TARGET_GROUP_EDIT',
          projectId: this.props.app.currentProjectId,
          id: data.id,
        },
      });
    });
  }

  companySizeRenderer(companySize) {
    let cS = null;
    if (companySize.length === 2) {
      cS = `${companySize.find(
        item => ['>', '>='].includes(item.operator)).size} - ${companySize.find(
        item => ['<', '<='].includes(item.operator)).size}`;
    } else if (companySize.length === 1) {
      cS = `${companySize[0].operator} ${companySize[0].size}`;
    }

    return (
      cS ?
        <div>
          <Icon type="team" />&nbsp;
          {cS}
        </div>
        :
        'N/A'
    );
  }

  showDeleteConfirm = (record) => {
    const _ = this;
    Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage(
        { id: 'Component.TargetGroup.Modal.Remove.Description' }),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk() {
        _.remove(record.id);
      },
    });
  }

  remove(id) {
    this.props.dispatch({ type: 'targetGroups/remove', payload: { id } }).then((response) => {
      if (response.success) {
        this.showNotifications();
        this.setState({ removedId: id });
      }
    });
  }

  showNotifications() {
    this.props.dispatch({ type: 'app/showNotifications' });
  }

  filterChange() {
    setTimeout(() => {
      const categories = this.props.form.getFieldsValue().categories;
      const filter = Object.assign(this.state.filter, { category_id: categories.length ? categories : undefined });
      this.setState({ filter });
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { Column } = Table;
    const { useCustomBranches } = this.props.app;
    const branchesTitleId = useCustomBranches ? 'Grid.Column.Branches' : 'Grid.Column.ClassificationCodes';
    const branchesColumnKey = useCustomBranches ? 'branches' : 'classification_codes';

    return (
      <div className={styles.containerLarge}>
        <Sticky
          className="sticky-bar"
          scrollElement=".ant-layout"
          stickyClassName="_sticky"
        >
          <div className="sticky-wrapper">
            <Row>
              <SearchComponent
                self={this}
                fieldPlaceholder={this.props.intl.formatMessage({ id: 'Component.TargetGroup.List.SearchByName' })}
              />
              <Col span={6}>
                <FormattedMessage id="Component.TargetGroup.List.FilterByCategory">
                  {msg => (
                    <FormItem className={styles.categorySelectWrp}>
                      {getFieldDecorator('categories', {
                        initialValue: [],
                      })(
                        <SelectInput
                          className={styles.categorySelect}
                          showArrow
                          onBlur={this.filterChange.bind(this)}
                          onDeselect={this.filterChange.bind(this)}
                          mode="multiple"
                          placeholder={msg}
                          options={this.props.categories.categoriesList}
                          filterOption={helpers.multipleSelectFilter}
                        />,
                      )}
                    </FormItem>
                  )}
                </FormattedMessage>
              </Col>
              <Col span={8} className="text-right">
                <Button
                  size="large"
                  type="primary"
                  onClick={() => this.props.dispatch({
                    type: 'app/goToRoute',
                    payload: {
                      routeName: 'TARGET_GROUP_NEW',
                      projectId: this.props.app.currentProjectId,
                    },
                  })}
                >
                  <Icon type="plus" />
                  <FormattedMessage id="Component.DynamicContent.CreateButton" />
                </Button>
              </Col>
            </Row>
          </div>
        </Sticky>
        <Spin spinning={this.props.loading.models.targetGroups}>
          <AjaxTable
            className={styles.dynamContentOverview}
            rowKey="id"
            updateKey={JSON.stringify([this.state.filter, this.state.removedId])}
            getData={this.getData.bind(this)}
          >
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.TargetGroup' })}
              dataIndex="name"
              key="name"
              sorter
              className={styles.tableColumnWrap}
              render={data => (<div
                data-label={this.props.intl.formatMessage({ id: 'Grid.Column.TargetGroup' })}
              >
                {data}
              </div>)}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Category' })}
              dataIndex="category"
              key="category"
              sorter
              className={styles.tableColumnWrap}
              render={data => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Category' })}
                >
                  {data && <span>{data.name}</span>}
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: branchesTitleId })}
              dataIndex={branchesColumnKey}
              key={branchesColumnKey}
              className={styles.tableColumnWrap}
              render={branches => (
                <div
                  data-label={this.props.intl.formatMessage({ id: branchesTitleId })}
                >
                  {(branches && branches.length) ?
                    <div className="cell-popover">
                      {/* either customer branch (name) or kompass code (label) */}
                      <MultiplyItemsColumnRender itemList={branches.map(i => i.name || i.label)} />
                    </div>
                    : <FormattedMessage id="Common.NoData" />
                  }
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.CompanySize' })}
              dataIndex="company_size"
              sorter
              key="company_size"
              render={data => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.CompanySize' })}
                >
                  {this.companySizeRenderer(data)}
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Campaign' })}
              dataIndex="campaigns"
              key="campaigns"
              className={styles.tableColumnWrap}
              render={c => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Campaign' })}
                >
                  {(c && c.length) ?
                    <div className="cell-popover">
                      <MultiplyItemsColumnRender itemList={c.map(i => i.name)} />
                    </div>
                    : <FormattedMessage id="Common.NoData" />
                  }
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Country' })}
              dataIndex="countries"
              key="countries"
              className={styles.tableColumnWrap}
              render={countries => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Country' })}
                >
                  {(countries && countries.length) ?
                    <div className="cell-popover">
                      <MultiplyItemsColumnRender itemList={countries.map(i => i.name)} />
                    </div>
                    : <FormattedMessage id="Common.NoData" />}
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.CountryRegions' })}
              dataIndex="country_groups"
              key="country_groups"
              className={styles.tableColumnWrap}
              render={countryRegions => (
                <div
                  data-label={this.props.intl.formatMessage({ id: 'Grid.Column.CountryRegions' })}
                >
                  {(countryRegions && countryRegions.length) ?
                    <div className="cell-popover">
                      <MultiplyItemsColumnRender itemList={countryRegions.map(i => i.name)} />
                    </div>
                    : <FormattedMessage id="Common.NoData" />}
                </div>
              )}
            />
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Active' })}
              dataIndex="disabled"
              key="disabled"
              className="text-center"
              render={(disabled) => {
                return (
                  <div
                    className="text-center"
                    data-label={this.props.intl.formatMessage({ id: 'Grid.Column.Active' })}
                  >
                    {disabled ?
                      <Icon type="close" /> :
                      <Icon type="check" />
                    }
                  </div>
                );
              }}
            />
            <Column
              title={this.props.intl.formatMessage({
                id: 'Grid.Column.Actions',
              })}
              key="actions"
              className="text-center"
              width={150}
              fixed="right"
              render={item => (
                <div className="actions" data-label={item.id}>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Edit',
                    })}
                  >
                    <Link to={`./${item.id}/edit/`}>
                      <PencilIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Copy',
                    })}
                  >
                    <button onClick={() => this.copyTG(item.id)}>
                      <CopyIcon />
                    </button>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Delete',
                    })}
                  >
                    <button onClick={() => this.showDeleteConfirm(item)}>
                      <TrashIcon />
                    </button>
                  </Tooltip>
                </div>
              )}
            />
          </AjaxTable>
        </Spin>
      </div>
    );
  }
}

export default connect(({ app, targetGroups, categories, loading }) =>
  ({ app, targetGroups, categories, loading }))(Form.create()(injectIntl(TargetGroupsList)));



// WEBPACK FOOTER //
// ./src/components/TargetGroups/TargetGroupsList/TargetGroupsList.js